import React from "react"
import {useSelector} from "react-redux";
import {Controller, useFormContext} from "react-hook-form";
import classNames from "classnames";
import RenderedHtmlContent from "../../../../../../shared/virtual_congress/components/rendered_html_content";
import CustomError from "../custom_error";
import {MuiPickersUtilsProvider, KeyboardTimePicker} from '@material-ui/pickers';
import ConditionalDivWrapper from "./conditional_div_wrapper";
import MomentUtils from '@date-io/moment';
import {convertFieldNameToClassName} from "../../../utils";

const BootstrapTimepicker = ({
                               name,
                               label,
                               options,
                               required,
                               variant,
                               readOnly,
                               defaultValue,
                               placeholder,
                               hint,
                               fieldValue,
                               errorMessage
                             }) => {
  const {register} = useFormContext();

  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"
  const isHorizontal = variant !== "vertical"

  return <div
    className={classNames(`form-group timepicker-container timepicker-${convertFieldNameToClassName(name)}-container`, {"row": isHorizontal})}>
    <label htmlFor={name}
           className={classNames(`r-label`, {[`col-md-${labelWidth} col-form-label-sm`]: isHorizontal})}>
      <RenderedHtmlContent html={label}/>
    </label>
    <ConditionalDivWrapper wrapWithDiv={isHorizontal} className={`col-md-${inputWidth}`}>
      <input
        {...register(name)}
        id={name}
        readOnly={readOnly}
        type={"time"}
        placeholder={placeholder}
        className={classNames("form-control form-control-sm w-100", {"is-invalid": errorMessage})}
        defaultValue={defaultValue}
      />
      {hint && <small className="form-text text-muted">
        <RenderedHtmlContent html={hint}/>
      </small>}
      <CustomError error={errorMessage}/>
    </ConditionalDivWrapper>
  </div>
}

const MaterialUiTimepicker = ({
                                name,
                                label,
                                options,
                                required,
                                variant,
                                readOnly,
                                defaultValue,
                                placeholder,
                                hint,
                                errorMessage
                              }) => {
  const {control} = useFormContext();

  return <div className={`form-group timepicker-container timepicker-${convertFieldNameToClassName(name)}-container`}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Controller
        name={name}
        control={control}
        render={({field: { onChange, value }}) => <KeyboardTimePicker
          label={<RenderedHtmlContent html={label}/>}
          onChange={(event) => {
            onChange(event.format("HH:MM"))
          }}
          value={value}
          id={name}
          variant={variant}
          error={!!errorMessage}
          margin="dense"
          fullWidth
          helperText={errorMessage || <RenderedHtmlContent html={hint}/>}
          InputProps={{
            readOnly: readOnly,
          }}
        />}
      />
    </MuiPickersUtilsProvider>
  </div>
}

const FlaveTimepicker = (props) => {
  const formFieldStyle = useSelector(state => state.form_field_style)

  switch (formFieldStyle) {
    case "material_ui":
      return <MaterialUiTimepicker {...props} variant={"standard"}/>
    case "material_ui_outlined":
      return <MaterialUiTimepicker {...props} variant={"outlined"}/>
    case "material_ui_filled":
      return <MaterialUiTimepicker {...props} variant={"filled"}/>
    case "boostrap_vertical":
      return <BootstrapTimepicker {...props} variant={"vertical"}/>
    case "boostrap_horizontal":
    default:
      return <BootstrapTimepicker {...props} variant={"horizontal"}/>
  }
}

export default FlaveTimepicker
